<template>
    <div class="flex items-center gap-2">
        <div
            class="cursor-pointer flex-center bg-[#F4F4F4] hover:bg-won-gray-light rounded h-6 w-6"
            v-tooltip="{ content: 'Increase Indent', placement: 'bottom' }"
        >
            <IncreaseIndentation
                @click="sinkListItem"
            />
        </div>

        <div
            class="cursor-pointer flex-center bg-[#F4F4F4] hover:bg-won-gray-light rounded h-6 w-6"
            v-tooltip="{ content: 'Decrease Indent', placement: 'bottom' }"
        >
            <DecreaseIndentation
                @click="liftListItem"
            />
        </div>

        <div
            class="cursor-pointer flex-center gap-1 bg-[#F4F4F4] hover:bg-won-gray-light rounded h-6 w-6"
            v-tooltip="{ content: 'Bulleted List', placement: 'bottom' }"
        >
            <BulletPointsIcon
                @click="bulletListHandler"
            />
        </div>
    </div>
</template>

<script setup>
import { toRefs } from "vue";
import { useTiptapStore } from "../../store/tiptap.store";

import { NodePos } from "@tiptap/vue-3";

import IncreaseIndentation from "../../icons/increase-indentation.vue"
import DecreaseIndentation from "../../icons/decrease-indentation.vue"
import BulletPointsIcon from "../../icons/bullet-list-icon.vue"

const tiptapStore = useTiptapStore();
const { editor } = toRefs(tiptapStore);

const bulletListHandler = () => {
    editor.value.commands.resetIndentation();
    editor.value.chain().focus().toggleBulletList().run();
}

const sinkListItem = () => {
    const nodePos = new NodePos(editor.value.state.selection.$anchor, editor.value)
    const result = nodePos.closest('bulletList');

    if(result == null){
        editor.value.chain().focus().indent().run();
    }else{
        editor.value.chain().focus().sinkListItem('listItem').run();
    }
};

const liftListItem = () => {
    const nodePos = new NodePos(editor.value.state.selection.$anchor, editor.value)
    const result = nodePos.closest('bulletList');

    if(result == null){
        editor.value.chain().focus().outdent().run();
    }else{
        editor.value.chain().focus().liftListItem('listItem').run();
    }
}
</script>
